import { useTranslation } from "react-i18next";

export const Rules = () => {
  const { t } = useTranslation();

  const data = t("rules", { returnObjects: true }) || {};

  const rules = Array.isArray(data.rules) ? data.rules : [];
  const rules2 = Array.isArray(data.rules2) ? data.rules2 : [];
  const rules3 = Array.isArray(data.rules3) ? data.rules3 : [];

  console.log('t', t);
  console.log('data', data);
  console.log('rules', rules);

  return (
    <div className="container-bg">
      <div className="container">
        <h3 className="container-title">
          {t("rules.title")}
        </h3>

        <p>{t("rules.intro")}</p>

        <ul className="cards">
          {rules.map((rule, index) => (
            <li key={index} className="card">
              {rule.title && <p className="card-title">{rule.title}</p>}
              {rule.text && <p className="card-text">{rule.text}</p>}
            </li>
          ))}

          {rules2.map((rule, index) => (
            <li key={rule.title || rule.img || index} className="card">
              {rule.title && <p className="card-title">{rule.title}</p>}
              {rule.text && <p className="card-text">{rule.text}</p>}
              {rule.img && <img src={rule.img} alt="wartości" />}
            </li>
          ))}

          {rules3.map((rule, index) => (
            <li key={rule.title || index} className="card big-card">
              {rule.title && <p className="card-title">{rule.title}</p>}
              {rule.text && <p className="card-text">{rule.text}</p>}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};